import React from "react";

import "./styles.scss";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import Button from "shared/components/Button";
import Logo from "shared/components/Logo";
import Space from "shared/components/Space";
import { NAME_SPACES } from "shared/locals/constants";
import { PATHS } from "utils/constants";

const SignIn = () => {
  const history = useHistory();
  const { t } = useTranslation(NAME_SPACES.AUTH);
  return (
    <div className={"auth-page"}>
      <Logo width={128} />
      <Space h={54} />
      <div className={"form"}>
        <p className={"title"}>{t("NEW_PASSWORD")}</p>
        <Space h={64} />
        <p className={"small-title"}>{t("SENT_EMAIL")}</p>
        <Space h={64} />
        <Button
          text={t("CONNECT")}
          fillWidth
          onClick={() => history.push(PATHS.AUTH.SIGN_IN)}
        />
      </div>
    </div>
  );
};

export default SignIn;
